import React from 'react'
import { v4 as uuidv4 } from 'uuid';
import LinkImage from '../../../../components/LinkImage/index.js'

const SingleCertification = (props) =>{
    return (
        <>
            <li className="subpara-text">
                {props.title} {props.date}
                {props.link !== undefined && props.link !== null && props.link !== '' &&
                    <a target="new" href={props.link}>
                        &nbsp;&nbsp;<LinkImage />
                    </a>
                }
                {(props.desc !== '' && props.desc !== null) && 
                    <><br/><p className="subheading-text mt-0"><u>Description</u> : {props.desc}</p></>
                }
            </li>
        </>
    )
}

function index(props) {
    return (
        <>
            <section>
                <p className="heading-text">CERTIFICATION PROGRAM</p>
                <ul type="disc">
                    {
                        props.certificates.map((element)=>{
                            return <SingleCertification key={uuidv4()} {...element}/>
                        })
                    }
                </ul>
            </section>
        </>
    )
}

export default index
